module.exports = __webpack_public_path__ + "static/media/patient-owl.0bb29039.svg";